(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDetailController', FrequentlyAskedQuestionStateHistoryDetailController);

    FrequentlyAskedQuestionStateHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FrequentlyAskedQuestionStateHistory', 'FrequentlyAskedQuestion', 'CustomUser'];

    function FrequentlyAskedQuestionStateHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, FrequentlyAskedQuestionStateHistory, FrequentlyAskedQuestion, CustomUser) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:frequentlyAskedQuestionStateHistoryUpdate', function(event, result) {
            vm.frequentlyAskedQuestionStateHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
